import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { Price } from "~/providers/general-provider";

interface PriceStoreState {
  selectedPrice?: Price;
  setSelectedPrice: (price?: Price) => void;
  priceDialogOpen: boolean;
  setPriceDialogOpen: (open: boolean) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}

export const usePriceStore = create<PriceStoreState>()(
  devtools((set) => ({
    isLoading: false,
    setIsLoading: (loading) => {
      set(() => ({ isLoading: loading }));
    },
    priceDialogOpen: false,
    setPriceDialogOpen: (open) => {
      set(() => ({ priceDialogOpen: open }));
    },
    setSelectedPrice: (button) => {
      set(() => ({ selectedPrice: button }));
    },
  })),
);
